import { inject, Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';

import { NotificationItem } from '@ps/notification-models';

import { NotificationApi } from '../api/notification.api';
import { NotificationUnreadCounts } from '../state/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly _notificationApi = inject(NotificationApi);

  // One page per tab, so a busy tab cannot push the other one out of the list.
  public notifications(limit: number): Observable<NotificationItem[]> {
    return forkJoin([
      this._notificationApi.notifications(limit, true),
      this._notificationApi.notifications(limit, false),
    ]).pipe(
      map(([needsAction, communication]) =>
        [...needsAction, ...communication].sort(
          (first, second) => second.createdAt - first.createdAt,
        ),
      ),
    );
  }

  public unreadCounts(): Observable<NotificationUnreadCounts> {
    return this._notificationApi.unreadCounts();
  }

  public viewAll(): Observable<number> {
    return this._notificationApi.viewAll();
  }

  public markViewed(
    notificationId: string,
    viewed: boolean,
  ): Observable<NotificationItem> {
    return this._notificationApi.markViewed(notificationId, viewed);
  }
}
